import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconIntegrations(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4.00092C3 3.44863 3.44772 3.00092 4 3.00092H10C10.5523 3.00092 11 3.44863 11 4.00092V10.0009C11 10.5532 10.5523 11.0009 10 11.0009H4C3.44772 11.0009 3 10.5532 3 10.0009V4.00092ZM5 5.00092V9.00092H9V5.00092H5Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 14.0009C3 13.4486 3.44772 13.0009 4 13.0009H10C10.5523 13.0009 11 13.4486 11 14.0009V20.0009C11 20.5532 10.5523 21.0009 10 21.0009H4C3.44772 21.0009 3 20.5532 3 20.0009V14.0009ZM5 15.0009V19.0009H9V15.0009H5Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3.00092C13.4477 3.00092 13 3.44863 13 4.00092V10.0009C13 10.5532 13.4477 11.0009 14 11.0009H20C20.5523 11.0009 21 10.5532 21 10.0009V4.00092C21 3.44863 20.5523 3.00092 20 3.00092H14ZM15 9.00092V5.00092H19V9.00092H15Z"
      />
      <path
        fill="currentColor"
        d="M17 13.0009C17.5523 13.0009 18 13.4486 18 14.0009V16.0009H20C20.5523 16.0009 21 16.4486 21 17.0009C21 17.5532 20.5523 18.0009 20 18.0009H18V20.0009C18 20.5532 17.5523 21.0009 17 21.0009C16.4477 21.0009 16 20.5532 16 20.0009V18.0009H14C13.4477 18.0009 13 17.5532 13 17.0009C13 16.4486 13.4477 16.0009 14 16.0009H16V14.0009C16 13.4486 16.4477 13.0009 17 13.0009Z"
      />
    </BaseIcon>
  );
}
